type SupportedEncoding = "utf8" | "base64";

const encoder = new TextEncoder();
export function createBuffer(textValue: string, encoding: SupportedEncoding): Uint8Array<ArrayBuffer> {
    switch (encoding) {
        case "utf8": {
            return encoder.encode(textValue);
        }
        case "base64": {
            const decodedValue = atob(textValue);
            const buffer = Uint8Array.from(decodedValue, (char) => char.codePointAt(0) ?? 0);
            return buffer;
        }
    }
}

const decoder = new TextDecoder();
export function fromBuffer(bufferValue: ArrayBufferLike, encoding: SupportedEncoding) {
    const buffer = new Uint8Array(bufferValue);
    switch (encoding) {
        case "utf8": {
            return decoder.decode(buffer);
        }
        case "base64": {
            const textValue = String.fromCharCode(...buffer);
            const encodedValue = btoa(textValue);
            return encodedValue;
        }
    }
}
